import style from '../../../common/common.scss';
import React from 'react';
import cns from 'classnames';
import { Table } from 'antd';
import { addUniqueField } from '../../../../../utils/util';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class PayFreeCash extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            customerData: [],
            supplierData: []
        };
    }

    getCustomer = () => {
        return [{
            title: '前五名客户',
            dataIndex: 'customerName'
        }];
    };

    getSupplier = () => {
        return [{
            title: '前五名供应商',
            dataIndex: 'supplierName'
        }];
    };

    formatResponse = (data) => {
        data = data || {};
        return {
            customerData: addUniqueField(data.customerList),
            supplierData: addUniqueField(data.supplierList)
        };
    };

    render() {
        const { loading, customerData, supplierData } = this.state;
        return (
            <div className="margin-top-40">
                <div className={cns(style.doubleTable, 'clearfix')}>
                    <Table
                        bordered
                        rowKey="id"
                        loading={loading}
                        dataSource={customerData}
                        columns={this.getCustomer()}
                        pagination={false}
                    />
                    <Table
                        bordered
                        rowKey="id"
                        loading={loading}
                        dataSource={supplierData}
                        columns={this.getSupplier()}
                        pagination={false}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/SupplierIsCustomer.jsx